var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSysStatistics = function SvgSysStatistics(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2 12a9.998 9.998 0 0 1 9.36-9.978.473.473 0 0 1 .23-.012 9.998 9.998 0 0 1 2.36 19.799A9.999 9.999 0 0 1 2 12.002V12Zm1 0a9.002 9.002 0 0 0 5.154 8.133 9 9 0 0 0 9.556-1.18.5.5 0 0 1-.21.047.5.5 0 0 1-.351-.148l-5.963-5.963a.504.504 0 0 1-.187-.389V3.057A9.014 9.014 0 0 0 3 12Zm14.855 6.145a.499.499 0 0 1 .063.632 8.985 8.985 0 0 0 .787-12.773l-6.5 6.5 5.65 5.64ZM12 11.295l6-6A8.959 8.959 0 0 0 12 3v8.295Z"
  })));
};
export default SvgSysStatistics;